import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import api from "../../services/api";

import MenuSuperior from "../Components/MenuSuperior"
import HeroStatic from "../Components/HeroStatic";
import Footer from "../Components/Footer";
import ListaConteudo from "./listaConteudo";

const Index = () => {
    const { tipo } = useParams();
    const [conteudos, setConteudos] = useState([]);

    useEffect(() => {
        buscaConteudos(tipo);
    }, [tipo]);

    const buscaConteudos = async (tipo) => {
        if (isNaN(tipo)) {
            //console.error("tipo deve ser um número.")
            return;
        }
        try {
            const response = await api.get(`/conteudos/tipoConteudo/${tipo}`);
            setConteudos(response.data);
        } catch (error) {
            console.error("Erro ao buscar conteúdos:", error);
        }
    };

    return (
        <div>
            <MenuSuperior />
            <HeroStatic title={'Treinamentos'} />
            {conteudos && (
                <div className="container-fluid team">
                    <ListaConteudo tipoConteudo={tipo} conteudos={conteudos} />
                </div>
            )}
            <Footer />
        </div>
    );
}
export default Index;